import { Button, Form, Col, Offcanvas, Card, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import WebService from "../../../utility/WebService";
import { Label } from "../../../components/Label/Label";
import HelperService from "../../../utility/HelperService";
import UploadFile from "../../../components/UploadFile/UploadFile";
import { IoClose } from "react-icons/io5";
import DocIcon from "../../../assets/images/doc-icon.svg";
import { ITowerInfo } from "./ManageTower";

interface PropData {
    isShow: boolean;
    isClose: Function;
    data: ITowerInfo | null;
    towerData: ITowerInfo[];
    project_uuid: string;
}

interface formInterface {
    id: string;
    uuid: string;
    tower_name: string;
    number_of_floors: number; // This field is currently not used
    image: string;
    project_uuid: string;
}

const AddUpdateTower = (props: PropData) => {
    const { handleSubmit, formState: { errors }, control, watch, reset, setValue } = useForm<formInterface>({});
    const watchAllFields = watch();
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [fileData, setFileData] = useState<any>(null);

    useEffect(() => {
        if (props.isShow) {
            if (props.data && !HelperService.isEmptyObject(props.data)) {
                reset(props.data);
                setIsEdit(true);
            } else {
                reset({});
                resetForm();
                setIsEdit(false);
            }
        }
    }, [props.isShow, props.data]);

    const handleFormSubmit = (data: formInterface) => {
        data.project_uuid = props.project_uuid;
        const url = "create-or-update-tower";
        WebService.postAPI({ action: url, body: data, id: "changePassword-btn" })
            .then((res: any) => {
                toast.success(res.message);
                if (fileData && fileData.file && !watchAllFields.id) {
                    uploadFile(fileData.file, res.tower_id);
                } else {
                    closeModal(true, res.project_data);
                }
            })
            .catch(() => { });
    };

    const closeModal = (e: boolean, data?: ITowerInfo[]) => {
        reset();
        resetForm();
        props.isClose(e, data);
    };

    const resetForm = () => {
        setValue('tower_name', '');
        setValue('id', '');
        setValue('image', '' as any);
        setValue('number_of_floors', 0);
        setValue('uuid', '');
        setFileData(null);
    };

    const onUploadFile = (data: any, name: string, size: string) => {
        if (fileData) {
            toast.error("You can not upload more than one file");
            setFileData({ ...fileData });
            return;
        }
        const blob = URL.createObjectURL(data);
        var isImageExte = /(\.(jpg|jpeg|png))$/i;
        var isVideo = /(\.(mp4))$/i;
        var isPdf = /(\.(pdf))$/i;
        let type = "";

        if (isImageExte.test(name)) {
            type = "IMAGE";
        }
        else if (isVideo.test(name)) {
            type = "VIDEO";
        } else if (isPdf.test(name)) {
            type = "PDF";
        }
        if (isEdit) {
            uploadFile(data);
        }

        setFileData({
            type: type,
            image: blob,
            file: data,
            name: name,
            size: size,
        });
        setValue("image", name);
    };

    const uploadFile = (data: any, towerId?: string) => {
        WebService.fileUploadAPI({
            action: `upload/project-mark/image`,
            key: "image",
            file: data,
            body: { project_uuid: props.project_uuid, tower_id: towerId || watchAllFields.id },
            id: "project_create_update_btn",
        })
            .then(async (res: any) => {
                setValue("image", res.file_name);
                setFileData(null);
                !watchAllFields.id && closeModal(true, res.project_data);
                toast.success("File uploaded successfully");
            })
            .catch(async (error: any) => { });
    };

    const onDeleteImage = () => {
        setFileData(null);
        setValue("image", '' as any);
    };




    return (
        <>
            <Offcanvas show={props.isShow} onHide={props.isClose} placement="end" className="offcanvas.offcanvas-ex-large">
                <Offcanvas.Header closeButton><Offcanvas.Title>{isEdit ? "Edit Tower" : "Add Tower"}</Offcanvas.Title></Offcanvas.Header>
                <Offcanvas.Body className="form-style">
                    <form className="form-style" onSubmit={handleSubmit(handleFormSubmit)}  >
                        <Row>
                            <Col lg={12} md={6} sm={12} className="mb-3">
                                {/* Tower Name */}
                                <Controller
                                    control={control}
                                    name="tower_name"
                                    rules={{ required: "Please Enter Tower Name" }}
                                    render={({ field: { onChange, onBlur }, fieldState: { isTouched } }) => (
                                        <div className="mb-2">
                                            <Form.Label>Tower Name</Form.Label><span className="text-danger">*</span>
                                            <input type="text" className="form-control" placeholder="Tower Name" onChange={onChange} onBlur={onBlur} value={watchAllFields.tower_name} />
                                            {(errors["tower_name"]?.message || Boolean(errors["tower_name"]?.message) || (isTouched && !watchAllFields.tower_name)) && (
                                                <div className="login-error">
                                                    <Label title={errors.tower_name?.message || "Please Enter First Name."} modeError={true} />
                                                </div>
                                            )}
                                        </div>
                                    )}
                                />

                                {/* <Form.Group className="mb-3">
                                    <Form.Label>No of floors</Form.Label>
                                    <span className="text-danger">*</span>
                                    <div className="input-group mb-1">
                                        <input type="text" className="form-control ps-3 p-2" placeholder="No of floors" onKeyPress={HelperService.allowOnlyNumericValue}
                                            {...register("number_of_floors", { required: true, min: 1 })} />
                                    </div>
                                    {errors.number_of_floors && (
                                        <div className="login-error">
                                            <Label title={errors.number_of_floors?.message || "Please Enter No. of Floors."} modeError={true} />
                                        </div>
                                    )}
                                </Form.Group> */}

                                {!fileData && (!watchAllFields.image || watchAllFields.image == "") && <UploadFile
                                    key={new Date().getTime()}
                                    onChange={(data: any, name: string, size: string) => { onUploadFile(data, name, size); }}
                                    acceptFileType={["jpg", "jpeg", "pdf", "png"]}
                                    message="Upload or Drag and Drop image"
                                    acceptedSize={5}
                                />}

                                {watchAllFields.image && <Card className={`border p-2 d-inline-block px-3 mb-3 me-2`}>
                                    <div className="d-flex gap-3 align-items-center">
                                        <div className="me-1">
                                            <IoClose size={20} onClick={() => { onDeleteImage(); }} className="text-secondary opacity-50 hover-effect cursor-pointer close" />
                                        </div>
                                        <div> <img src={DocIcon} width={40} height={40} alt="" /> </div>
                                        <div>
                                            <p className="font-medium font-16 mb-0">{watch().image}</p>
                                        </div>
                                    </div>
                                </Card>
                                }

                            </Col>

                        </Row>
                        <div className="text-center border-top">
                            <Button variant="dark" className="btn-brand-1 px-5 mt-3 mb-3 me-2" type="submit" id="changePassword-btn" >
                                {isEdit ? "Update" : "Add"}
                            </Button>
                            <Button variant="light" className="btn-brand-1 px-5 mt-3 mb-3" type="button" onClick={() => closeModal(false)}>
                                Close
                            </Button>
                        </div>
                    </form>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
};

export default AddUpdateTower;
